import { OrbConnectionManager } from "../services/connections/OrbConnectionManager";
import { AuthOverlay } from "../services/ui/AuthOverlay";
import { global } from "./GlobalState";
import SceneManager from "./SceneManager";
let activeUiOverlayCount = 0;
const overlayBlockStack = [];
function onWindowResizeOld() {
    window.addEventListener('resize', function () {
        global.camera.aspect = window.innerWidth / window.innerHeight;
        global.camera.updateProjectionMatrix();
        global.renderer.setSize(window.innerWidth, window.innerHeight);
        // Update composer size
        global.composer.setSize(window.innerWidth, window.innerHeight);
    });
}
export function onWindowResize() {
    window.addEventListener('resize', () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        console.log('[Viewport] Resize detected', { width: window.innerWidth, height: window.innerHeight });
        const w = window.innerWidth, h = window.innerHeight;
        global.camera.aspect = w / h;
        global.camera.updateProjectionMatrix();
        applyRendererPixelRatio();
        global.renderer.setSize(w, h, false);
        const pixelRatio = global.renderer.getPixelRatio();
        if (typeof ((_a = global.composer) === null || _a === void 0 ? void 0 : _a.setPixelRatio) === 'function') {
            global.composer.setPixelRatio(pixelRatio);
        }
        (_b = global.composer) === null || _b === void 0 ? void 0 : _b.setSize(w, h);
        // OutlinePass has its own resolution
        if (global.outlinePass)
            (_d = (_c = global.outlinePass).setSize) === null || _d === void 0 ? void 0 : _d.call(_c, w, h);
        if (global.renderWorkerSession) {
            global.renderWorkerSession.resize({
                devicePixelRatio: (_h = (_g = (_f = (_e = global.renderer) === null || _e === void 0 ? void 0 : _e.getPixelRatio) === null || _f === void 0 ? void 0 : _f.call(_e)) !== null && _g !== void 0 ? _g : window.devicePixelRatio) !== null && _h !== void 0 ? _h : 1,
                width: w,
                height: h,
            });
        }
        //might remove this
        OrbConnectionManager.getInstance().updateResolution();
    });
}
export function applyRendererPixelRatio() {
    var _a, _b, _c, _d, _e;
    if (!global.renderer)
        return;
    const preferredMax = global.rendererPixelMode === 'crisp'
        ? global.legacyMaxRendererPixelRatio
        : global.reducedMaxRendererPixelRatio;
    global.maxRendererPixelRatio = preferredMax;
    const pixelRatio = Math.min(window.devicePixelRatio || 1, preferredMax);
    global.renderer.setPixelRatio(pixelRatio);
    if (typeof ((_a = global.composer) === null || _a === void 0 ? void 0 : _a.setPixelRatio) === 'function') {
        global.composer.setPixelRatio(pixelRatio);
    }
    if (global.renderWorkerSession) {
        global.renderWorkerSession.resize({
            devicePixelRatio: (_e = (_d = (_c = (_b = global.renderer) === null || _b === void 0 ? void 0 : _b.getPixelRatio) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : window.devicePixelRatio) !== null && _e !== void 0 ? _e : 1,
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }
}
export function toggleRendererPixelMode() {
    global.rendererPixelMode = global.rendererPixelMode === 'crisp' ? 'performance' : 'crisp';
    applyRendererPixelRatio();
    global.chat.addMessage(`🖥️ Renderer pixel mode: ${global.rendererPixelMode === 'crisp' ? 'Crisp detail' : 'Performance'}`);
}
export function blocker() {
    const blocker = document.getElementById('blocker');
    const instructions = document.getElementById('instructions');
    const isMobileDevice = isMobile();
    console.log('[Input] Initializing blocker overlay', { isMobileDevice });
    AuthOverlay.initialize();
    const enterScene = () => {
        var _a, _b;
        if (!isMobileDevice && !global.controls.isLocked) {
            const canvas = (_a = global.renderer) === null || _a === void 0 ? void 0 : _a.domElement;
            (_b = canvas === null || canvas === void 0 ? void 0 : canvas.focus) === null || _b === void 0 ? void 0 : _b.call(canvas);
            try {
                global.controls.lock();
            }
            catch (error) {
                console.warn('[Input] Pointer lock request failed', error);
                AppState.setBlocked(false);
                return;
            }
        }
        else {
            AppState.setBlocked(false);
        }
    };
    instructions.addEventListener('click', (e) => {
        e.preventDefault();
        enterScene();
    });
    instructions.addEventListener('touchstart', (e) => {
        e.preventDefault();
        enterScene();
    }, { passive: false });
    //These need to be integrated with the controls manager somehow
    global.controls.addEventListener('lock', () => {
        AppState.setBlocked(false);
        console.log('[Input] Pointer lock acquired');
    });
    global.controls.addEventListener('unlock', () => {
        var _a;
        if (!isMobileDevice) {
            const overlayKeepsBlocked = (_a = overlayBlockStack[overlayBlockStack.length - 1]) !== null && _a !== void 0 ? _a : false;
            if (overlayKeepsBlocked || activeUiOverlayCount === 0) {
                AppState.setBlocked(true);
            }
            else {
                AppState.setBlocked(false);
            }
        }
        console.log('[Input] Pointer lock released');
    });
    document.addEventListener('pointerlockerror', (event) => {
        console.warn('[Input] Pointer lock error', event);
        if (!global.controls.isLocked && activeUiOverlayCount === 0) {
            AppState.setBlocked(true);
        }
    });
    //scene.add(global.controls.getObject());
    //this needs to work across scenes
    SceneManager.getInstance().getScene().add(global.controls.getObject());
    console.log('[Input] Blocker setup complete');
}
export function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}
// =====================
// Blocker (pointer lock + state)
// =====================
function blockerNew() {
    const isMobileDevice = isMobile();
    // A single entry handler: ask for pointer lock on user gesture
    const requestEnter = (e) => {
        e.preventDefault();
        if (!isMobileDevice && !global.controls.isLocked) {
            global.controls.lock(); // Do NOT flip isBlocked here; wait for 'lock'
        }
        else {
            // Mobile or already locked: flip state now
            AppState.setBlocked(false);
        }
    };
    const instructions = document.getElementById('instructions');
    instructions.addEventListener('click', requestEnter);
    instructions.addEventListener('touchstart', requestEnter, { passive: false });
    // Pointer lock actually acquired → mark unblocked
    global.controls.addEventListener('lock', () => {
        AppState.setBlocked(false);
    });
    // Pointer lock released → mark blocked
    global.controls.addEventListener('unlock', () => {
        if (!isMobileDevice) {
            if (activeUiOverlayCount === 0) {
                AppState.setBlocked(true);
            }
            else {
                AppState.setBlocked(false);
            }
        }
    });
    // Initial state render happens via AppState.subscribe
    SceneManager.getInstance().getScene().add(global.controls.getObject());
}
const AppState = (() => {
    let isBlocked = true; // start blocked
    const listeners = [];
    return {
        get isBlocked() { return isBlocked; },
        setBlocked(next) {
            if (isBlocked === next)
                return;
            isBlocked = next;
            listeners.forEach(fn => fn(isBlocked));
        },
        subscribe(fn) {
            listeners.push(fn);
            // initial sync
            fn(isBlocked);
            return () => {
                const i = listeners.indexOf(fn);
                if (i >= 0)
                    listeners.splice(i, 1);
            };
        }
    };
})();
// =====================
// Audio (subscribes to AppState)
// =====================
function getBgm() {
    return document.getElementById('bgm');
}
function safePlay(el) {
    return el.play().catch(() => { });
}
function fadeVolume(el, to, ms) {
    const stepMs = 50;
    const steps = Math.max(1, Math.floor(ms / stepMs));
    const from = el.volume;
    let i = 0;
    const id = setInterval(() => {
        i += 1;
        el.volume = from + (to - from) * (i / steps);
        if (i >= steps)
            clearInterval(id);
    }, stepMs);
}
// Prime audio silently on load (muted autoplay is allowed)
window.addEventListener('load', () => {
    const bgm = getBgm();
    if (!bgm)
        return;
    bgm.volume = 0;
    bgm.muted = true;
    safePlay(bgm);
});
// Audio reacts ONLY to AppState + tab visibility
AppState.subscribe((isBlocked) => {
    const bgm = getBgm();
    if (!bgm)
        return;
    if (isBlocked) {
        bgm.pause();
        return;
    }
    // Unblocked
    if (document.hidden) {
        // tab hidden: stay paused even if unblocked
        bgm.pause();
        return;
    }
    // Play + fade in on becoming unblocked
    bgm.muted = false;
    safePlay(bgm);
    // if volume is very low, fade up once
    if (bgm.volume < 0.045)
        fadeVolume(bgm, 0.05, 1200);
});
// Pause/resume on tab visibility, respecting AppState
document.addEventListener('visibilitychange', () => {
    const bgm = getBgm();
    if (!bgm)
        return;
    if (document.hidden) {
        bgm.pause();
    }
    else if (!AppState.isBlocked) {
        // Resume only if unblocked
        safePlay(bgm);
    }
});
// =====================
// UI (subscribes to AppState)
// =====================
function applyBlockerUI(isBlocked) {
    const blocker = document.getElementById('blocker');
    const instructions = document.getElementById('instructions');
    if (isBlocked) {
        blocker.style.display = 'block';
        instructions.style.display = activeUiOverlayCount === 0 ? '' : 'none';
    }
    else {
        blocker.style.display = 'none';
        instructions.style.display = 'none';
    }
}
AppState.subscribe(applyBlockerUI);
export function beginUiOverlay(options) {
    var _a, _b, _c;
    const keepBlocked = (_a = options === null || options === void 0 ? void 0 : options.keepBlocked) !== null && _a !== void 0 ? _a : false;
    overlayBlockStack.push(keepBlocked);
    activeUiOverlayCount = overlayBlockStack.length;
    document.body.classList.add('oe-overlay-active');
    if (keepBlocked) {
        AppState.setBlocked(true);
        (_c = (_b = global.controls).unlock) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    else {
        AppState.setBlocked(false);
    }
}
export function endUiOverlay() {
    var _a, _b, _c, _d, _e;
    if (overlayBlockStack.length === 0)
        return;
    const endedKeepBlocked = (_a = overlayBlockStack.pop()) !== null && _a !== void 0 ? _a : false;
    activeUiOverlayCount = overlayBlockStack.length;
    const keepBlocked = overlayBlockStack[overlayBlockStack.length - 1];
    if (keepBlocked !== undefined) {
        AppState.setBlocked(keepBlocked);
        if (keepBlocked) {
            (_c = (_b = global.controls).unlock) === null || _c === void 0 ? void 0 : _c.call(_b);
        }
        return;
    }
    document.body.classList.remove('oe-overlay-active');
    if (endedKeepBlocked) {
        AppState.setBlocked(true);
        (_e = (_d = global.controls).unlock) === null || _e === void 0 ? void 0 : _e.call(_d);
        return;
    }
    const shouldLock = !isMobile() && !global.controls.isLocked;
    if (shouldLock) {
        window.setTimeout(() => {
            var _a, _b;
            if (!global.controls.isLocked) {
                try {
                    (_b = (_a = global.controls).lock) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                catch (error) {
                    console.warn('[UI] Failed to relock pointer after overlay close', error);
                    AppState.setBlocked(true);
                }
            }
        }, 0);
    }
    else if (!isMobile()) {
        AppState.setBlocked(!global.controls.isLocked);
    }
}
export function hasActiveUiOverlay() {
    return activeUiOverlayCount > 0;
}
